import React, { Fragment } from 'react';
import {
    Link,
    useLocation
} from 'react-router-dom'
import { useDispatch } from "react-redux";
import { 
    addNextPage,
    addFormData
 } from "../redux/index";
import styled from "styled-components";

const StyledComponentLink = styled(Link)`
    display: ${props => (        
        props.ismobile ? 'none' : 'inline-block'
    )};

    :visited {
        text-decoration: none;
        color: #000;
    }

    ${props => props.theme.mediaQueries.medium}{
        :hover {
            opacity: 0.7;
            text-decoration: none;
        }
    };


`

const StyledLink = ({
    className,
    to,
    reduxNextPage,
    children,
    isMobile,
    ...props
}) => {
    const dispatch = useDispatch();

    const handleOnClick = () => {
        if (reduxNextPage) {
            dispatch(addNextPage(reduxNextPage));
        }
    }

    return (
        <StyledComponentLink
            to={{
                pathname: to,
                state: {
                    background: {
                        pathname: "/",
                        search: sessionStorage.getItem('locationSearch')
                    }
                }
            }}
            onClick={handleOnClick}
            {...props}
            ismobile={isMobile}
        >
            {children}
        </StyledComponentLink>
    )
}

export default StyledLink;